<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
        <!-- p-0 h-100 overflow-y-hidden -->
        <!-- <img src="~/../assets/images/left-banner.jpg" style="height: 100%;" alt=""> -->
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15">
        <grid-row class="justify-content-center h-100 pb-30">
            <grid-col col="6" mobile="12">
                <grid-col col="12">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "ConfirmIDDetails" | translate }}
                    </div>
                </grid-col>
                <grid-col col="12">
                    <div class="form-group mt-50">
                        <label class="no-mark">
                            {{ "NAMEASPERID" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter">
                    </div>
                    <div class="form-group mt-25">
                        <label class="no-mark">
                            {{ "IdNumber" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter">
                    </div>
                    <div class="form-group mt-25">
                        <label class="no-mark">
                            {{ "DateOfBirth" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter">
                    </div>
                    <div class="form-group mt-25">
                        <label class="no-mark">
                            {{ "IDEXPIRY" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter">
                    </div>
                    <div class="form-group mt-25">
                        <label class="no-mark">
                            {{ "IDISSUER" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter">
                    </div>
                    <div class="mt-46 mt-mobile-50 pt-mobile-20">
                        <div class="custom-checkbox">
                            <input type="checkbox" id="check3">
                            <label for="check3" class="inside-link align-items-center-2">
                                <span> {{"IConfirmIDDetailsCorrect" | translate}} </span>
                            </label>
                        </div>
                    </div>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between mt-50">
                        <grid-col col="auto">
                            <button class="btn-back" (click)="back()">
                                <i class="icon-back"></i>
                            </button>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft" (click)="cardRequestLimitSetting()">
                                {{ "NEXT" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-col>
        </grid-row>
    </div>
</div>